/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const FolderBigIcon: React.FC = (): JSX.Element => (
  <svg width="178" height="174" viewBox="0 0 178 174" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 6C1 3.23858 3.23858 1 6 1H59.405C60.3743 1 61.3228 1.28177 62.1349 1.81101L75.8356 10.7396C76.9726 11.4805 78.3004 11.875 79.6575 11.875H172C174.761 11.875 177 14.1136 177 16.875V168C177 170.761 174.761 173 172 173H6C3.23858 173 1 170.761 1 168V6Z"
      fill="white"
      stroke="#EBF1F5"
      strokeWidth="2"
    />
  </svg>
);
